<template>
  <div id="Warehousetable">
    <el-table
      ref="tableRef"
      :data="tableData"
      @row-click="rowclick"
      @row-dblclick="rowdblclick"
      @header-dragend="headerdragend"
      @selection-change="handleSelectionChange"
      highlight-current-row
      border
      :fit="asdaaf"
      style="width: 100%;"
      :height="heights==true?tableHeight12:'484'"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}"
      :row-style="{fontSize:'16px',height:'37px',padding:'0'}"
    >
      <el-table-column v-if="showSelect" type="selection" width="55" align="center"></el-table-column>
      <el-table-column
        v-if="show_Select"
        width="100"
        height="500"
        align="center"
        prop="BarCode"
        fixed="left"
      >
        <template slot="header">选择</template>
        <template slot-scope="scope">
          <el-button type="text" @click.native.prevent="addRow(scope.$index)">选择当前</el-button>
        </template>
      </el-table-column>
      <el-table-column width="50" height="500" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i :class="isInners" @click="clickIcon" style="color:#2594ff;font-size:18px"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column width="60" align="center" label="类型">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>
      <el-table-column width="60" align="center" label="图片" v-if="showPicCloum">
        <template slot-scope="scope">
          <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
            <img
              v-if="scope.row.ImageUrl"
              :src="scope.row.ImageUrl"
              style="width:26px;height: 26px;display:block;"
              @click="imgclick(scope.row.ImageUrl)"
            />
            <span
              v-else-if="scope.row.FullName!='' && scope.row.BaseCode!='' && !scope.row.ImageUrl"
            >无</span>
          </div>
        </template>
      </el-table-column>
      <template v-for="(obj,index) in ObtainHeader">
        <el-table-column
          :width="obj.Width==''?'':obj.Width"
          align="center"
          :index="index"
          :key="index"
          :prop="obj.Key"
          :label="obj.Rename"
          v-if="obj.Key!='IsDir'&&obj.Show"
        ></el-table-column>
      </template>
      <el-table-column
        v-if="columnS"
        align="center"
        fixed="left"
        label="操作"
        width="150"
        class="asdadfas"
      >
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="mini">修改</el-button>
          <el-button deleteClick @click="deleteClick(scope.row)" type="text" size="mini">删除</el-button>
          <el-button
            id="btn"
            deleteClick
            @click="Discontinuation(scope.row,scope.$index)"
            type="text"
            size="mini"
            v-if="StopedNameIfShow||ifshowsss"
          >{{scope.row.StopedName != "停用" ? "停用" : "启用"}}</el-button>
          <el-button v-if="!StopedNameIfShow" id="btn" deleteClick type="text" size="mini">
            <el-dropdown trigger="click" class="clearfix">
              <el-button type="text" size="mini">更多</el-button>
              <el-dropdown-menu slot="dropdown" @click="asdfgh(scope.row)">
                <el-dropdown-item class="clearfix">
                  <el-button
                    id="btn"
                    deleteClick
                    @click="Discontinuation(scope.row,scope.$index)"
                    type="text"
                    size="mini"
                  >{{scope.row.StopedName != "停用" ? "停用" : "启用"}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="mini"
                    @click="constraintclick(scope.row,scope.$index)"
                    :disabled="scope.row.HandCheck==0?false:true"
                  >绑定</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="mini"
                    @click="deleteClickS(scope.row,scope.$index)"
                    :disabled="scope.row.HandCheck==1?false:true"
                  >解绑</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="mini"
                    @click="Relieveclick(scope.row,scope.$index)"
                  >设置</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        v-if="columnSs"
        align="center"
        fixed="left"
        label="操作"
        width="150"
        class="asdadfas"
      >
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="mini">{{textVal}}</el-button>
          <el-button
            v-if="deleteC"
            deleteClick
            @click="deleteClick(scope.row)"
            type="text"
            size="mini"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="paginationshow"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20,50,100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
    <el-dialog :visible.sync="dialogVisible" class="image_sty">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  name: "Warehousetable",
  data() {
    return {
      tableHeight12: window.innerHeight - 300 + "px",
      heightss: this.heights,
      StopedNameIfShow: this.StopedNameifshow,
      ifshowsss: this.ifshowss,
      paginationshow: this.pagination,
      isInner: this.isInners,
      asdaaf: true,
      data: this.tableData,
      icons: false,
      icon: false,
      column: this.columnS,
      columnSs: this.ColumnSs,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes, //每页显示数量
      // tableData: [],
      img: this.imgs,
      // filetext: require("../../assets/images/icon_set.png"),
      filetext: "",
      file: "",
      Discontext: true,
      Discontexts: "",
      Discon: [],
      taData: [],
      taData1: this.ObtainHeader,
      IfShows: this.IfShow,
      Hierarchy: this.HierarchyS,
      showsummary: this.ShowSummary,
      textVal: this.TextVal,
      deleteC: this.deleteCc,

      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  props: {
    pagination: {
      type: Boolean,
      default: false,
    },
    ColumnSs: {
      type: Boolean,
      default: false,
    },
    TextVal: {
      type: String,
      default: "盘点",
    },
    deleteCc: {
      type: Boolean,
      default: true,
    },
    StopedNameifshow: {
      type: Boolean,
      default: true,
    },
    ifshowss: {
      type: Boolean,
      default: false,
    },
    ShowSummary: {
      type: Boolean,
      default: true,
    },
    HierarchyS: Array,
    IfShow: {
      type: Boolean,
    },
    tableData: Array,
    ObtainHeader: Array,
    currentPages: Number,
    totals: Number,
    pageSizes: Number,
    imgs: String,
    heights: {
      type: Boolean,
    },
    columnS: {
      type: Boolean,
    },
    isInners: String,
    // 表格是否显示商品图片列
    showPicCloum: {
      type: Boolean,
      default: false,
    },
    // 是否显示选项框列
    showSelect: {
      type: Boolean,
      default: true,
    },
    show_Select: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addRow(e) {
      let datas = this.tableData[e];
      this.$emit("rowclick", datas, "确定");
    },
    imgclick(ImageUrl) {
      // ImageUrl =
      //   "http://img1.cheshi-img.com/product/1_1024/p/34800/34863/522f255be4a77.jpg";
      this.dialogImageUrl = ImageUrl;
      this.dialogVisible = true;
    },
    headerdragend(newWidth, oldWidth, column, event) {
      let Baseno = false;
      this.ObtainHeader.map((item) => {
        if (item.Key == column.property) {
          Baseno = item.BaseNo;
          return;
        }
      });
      if (Baseno != false) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.$attrs.pargam.Model,
          data: [
            {
              BaseNo: Baseno,
              Width: newWidth,
            },
          ],
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams),
          })
          .then((res) => {})
          .catch((err) => {
            console.log(err);
          });
      }
    },
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    // 复选框改变是触发
    handleSelectionChange(data) {
      this.$emit("handleSelectionChange", data);
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 双击一行
    rowdblclick(obj, column) {
      if (column.type == "selection") {
        return;
      }
      this.$emit("dblclick", obj);
    },
    // // 单击某一行
    rowclick(obj) {
      console.log(obj);
      this.$emit("rowclick", obj);
    },
    handleClick(obj) {
      this.$emit("handleClick", obj);
    },

    deleteClick(index) {
      this.$emit("deleteClick", index);
    },
    deleteClickS(data, index) {
      this.$emit("deleteClickS", data, index);
    },
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    },
    Relieveclick(data, index) {
      // console.log(data, index);
      this.$emit("Relieveclick", data, index);
    },
    constraintclick(data, index) {
      this.$emit("constraintclick", data, index);
    },
  },
  watch: {
    ObtainHeader: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
      deep: true,
    },
    tableData: {
      handler(newValue, oldValue) {
        console.log(newValue);
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
      deep: true,
    },
    currentPage: {
      handler(newValue, oldValue) {
        // console.log(newValue);
      },
      deep: true,
    },
  },
  created() {},
};
</script>
<style lang="less" >
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  text-align: center;
  z-index: 1000;
}
.el-table--medium td,
.el-table--medium th {
  padding: 0;
}
.el-table .cell {
  white-space: nowrap;
}
.image_sty .el-dialog__header {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/Warehousetable/Warehousetable.vue